import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { FcpAccordionModule, FcpButtonModule, FcpSummaryBarModule, FcpBadgeModule } from 'fc-ui-components';
import { FcpTagComponent, FcpIconComponent } from 'fc-design-system';

import { ProductEmptyComponent } from './empty/empty.component';
import { ProductHeaderComponent } from './header/header.component';
import { ProductPriceDetailsComponent } from './price-details/price-details.component';
import { PdpGalleryComponent } from './gallery/gallery.component';
import { PdpAttributesComponent } from './product-attributes/product-attributes.component';
import { ProductDetailsSummaryComponent } from './summary-bar/product-details-summary.component';

import { PipesModule } from 'pipes';
import { ResponsiveWrapperModule } from '../../../../components/responsive-wrapper/responsive-wrapper.module';
import { SkeletonModule } from 'components/skeleton/skeleton.module';
import { DirectivesModule } from 'app/directives/directives.module';
import { ImageDialogModule } from '../../image-dialog/image-dialog.module';

const components = [
    ProductEmptyComponent,
    ProductHeaderComponent,
    ProductPriceDetailsComponent,
    PdpGalleryComponent,
    PdpAttributesComponent,
    ProductDetailsSummaryComponent
];
@NgModule({
    imports: [
        CommonModule,
        PipesModule,
        TranslateModule,
        DirectivesModule,
        ImageDialogModule,
        ResponsiveWrapperModule,
        FcpAccordionModule,
        FcpSummaryBarModule,
        FcpButtonModule,
        SkeletonModule,
        FcpBadgeModule,
        FcpTagComponent,
        FcpIconComponent
    ],
    declarations: components,
    exports: components
})
export class ProductDetailsModule {}
